/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Seo_Trainer_Shop_DescriptionInputs */

const en_seo_trainer_shop_description = /** @type {(inputs: Seo_Trainer_Shop_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: products you can buy online.`)
};

const pl_seo_trainer_shop_description = /** @type {(inputs: Seo_Trainer_Shop_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: produkty, które kupisz online.`)
};

/**
* | output |
* | --- |
* | "{name}: products you can buy online." |
*
* @param {Seo_Trainer_Shop_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_trainer_shop_description = /** @type {((inputs: Seo_Trainer_Shop_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Trainer_Shop_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_trainer_shop_description(inputs)
	return en_seo_trainer_shop_description(inputs)
});